import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Select, Button, Popconfirm } from '@smartplatform/ui';
import store from '../../store';


@observer
export default class MenuItem extends React.Component {

	@observable changed = false;

	constructor(props) {
		super(props);
		this.item = props.item || new store.model.MenuItem();
		if (!props.item) {
			console.log('new', this.item);
		};
		if (!props.item) {
			this.item.column = this.props.column
		};
	};

	onNameChange = (e) => {
		this.item.name = e.target.value;
		this.changed = true;
	};
	onLinkChange = (e) => {
		this.item.link = e.target.value;
		this.changed = true;
	};
	onColumnChange = (e) => {
		this.item.column = e;
		this.changed = true;
	};
	onColorChange = (e) => {
		this.item.color = e.target.value;
		this.changed = true;
	};

	up = async () => {
		const prevWeight = this.props.prev.weight;
		this.props.prev.weight = this.item.weight;
		this.item.weight = prevWeight;
		await this.props.prev.save();
		await this.item.save();
		this.props.onChange && this.props.onChange();
	};

	down = async () => {
		const nextWeight = this.props.next.weight;
		this.props.next.weight = this.item.weight;
		this.item.weight = nextWeight;
		await this.props.next.save();
		await this.item.save();
		this.props.onChange && this.props.onChange();
	};

	save = async () => {
		this.changed = false;
		await this.item.save();
		if (!this.props.item) {
		this.item.weight = this.item.id * 10;
		await this.item.save()}
		this.props.onChange && this.props.onChange();
	};

	delete = async () => {
		await this.item.delete();
		this.props.onChange && this.props.onChange();
	};

	render() {
		const { prev, next, isNew } = this.props;
		return (
			<div className="menu-item">
				<div className="name">
					<input type="text" value={this.item.name || ''} placeholder='название' onChange={this.onNameChange} /></div>
				<div className="link">
					<input type="text" value={this.item.link || ''} placeholder='путь' onChange={this.onLinkChange} /></div>
				<Select className="drop-down-md" noSearch isRequired value={this.item.column || ''} onChange={this.onColumnChange} items={[
					{ label: 'Информация', value: 1 },
					{ label: 'Структура', value: 2 },
					{ label: 'Деятельность', value: 3 },
					{ label: 'События', value: 4 },
				]} />
				<div className='color'>
					<input type="color" value={this.item.color || "#ffffff"} onChange={this.onColorChange}></input>		</div>
				<div className="order">
					<FontAwesomeIcon icon={faChevronUp} className={'order-btn' + ((!prev || isNew) ? ' disabled' : '')} onClick={this.up} />
					<FontAwesomeIcon icon={faChevronDown} className={'order-btn' + ((!next || isNew) ? ' disabled' : '')} onClick={this.down} />
				</div>
				<div className="actions">
					<Button disabled={!this.changed} onClick={this.save} className="btn-primary">Ok</Button>
					{!isNew && <Popconfirm className="delete-btn" onConfirm={this.delete} content={'Удалить?'}>
						<FontAwesomeIcon icon={faTrash} />
					</Popconfirm>}
				</div>
			</div>
		)
	}
}
